import { Eye } from 'lucide-react';
import { useAuth } from './useAuth';

/**
 * Subtle persistent "Read-only" pill for users whose only role is the default
 * viewer role. Rendered from RootLayout in the bottom-right corner column
 * (CornerStack, 2026-10-28) so it needs no hooks into the layout headers or
 * the shared NADC navbar (an external script that can't carry app-specific
 * badges). The column places it above the mobile bottom nav and the Guide
 * and NADC.AI buttons, and hides it in print.
 */
export function ReadOnlyBadge() {
  const { isReadOnly } = useAuth();
  if (!isReadOnly) return null;

  return (
    <div
      title="Your account has view-only access to DemoOps. Ask an administrator for a role to make changes."
      className="pointer-events-auto flex cursor-help items-center gap-1.5 rounded-full border border-dashed border-graphite-600 bg-graphite-900/90 px-3 py-1.5 text-xs font-medium uppercase tracking-wide text-graphite-400 shadow-lg"
    >
      <Eye className="h-3.5 w-3.5" aria-hidden="true" />
      Read-only
    </div>
  );
}
